import React, { useRef, useEffect } from 'react'
import { HiOutlineArrowRight } from 'react-icons/hi'
import CheckboxGroup from '@/components/common/CheckboxGroup'
import MainCheckBoxGroup from '@/components/common/MainCheckBoxGroup'
import Button from '@/components/common/Button'
import { Disclosure } from '@headlessui/react'
import { MdKeyboardArrowDown } from 'react-icons/md'
import { getColumns } from '@/utils/General.util'
import classNames from 'classnames'
import styles from '@/styles/components/speaker.module.scss'

const Category = ({
  categories = [],
  isMobileOpen,
  selectedCategories,
  selectedCategoriesNames,
  selectedSpeakerTypes,
  selectedSpeakerTypeNames,
  handleCategoryChange,
  handleFilterSpeakers,
  onParentCategoryClick,
}) => {
  const divRef = useRef()

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (divRef?.current && !divRef.current.contains(event.target) && !isMobileOpen) {
        if (
          selectedCategories?.length !== selectedCategoriesNames?.length ||
          selectedSpeakerTypes?.length !== selectedSpeakerTypeNames?.length
        ) {
          handleFilterSpeakers && handleFilterSpeakers()
        }
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [handleFilterSpeakers])

  return (
    <>
      <div className="px-4 pb-4 md:hidden top-4">
        {categories?.map((cat, index) => (
          <div className="relative w-full outline-none" key={index}>
            <CheckboxGroup
              name="categories"
              value={selectedCategories}
              onChange={handleCategoryChange}
            >
              {(Checkbox) => (
                <>
                  <div>
                    <Disclosure>
                      {({ open }) => (
                        <>
                          <Disclosure.Button className="flex justify-between w-full px-2 py-5 text-base font-extrabold leading-6 tracking-wider text-white tagline-font">
                            <span
                              className="cursor-pointer"
                              onClick={() => onParentCategoryClick(cat?.category)}
                            >
                              {cat.category.toUpperCase()}
                            </span>
                            <MdKeyboardArrowDown
                              className={`${
                                open
                                  ? 'mt-1 rotate-180 transform h-5 w-5'
                                  : 'text-white mt-1 h-5 w-5'
                              }`}
                            />
                          </Disclosure.Button>
                          <Disclosure.Panel className="text-gray-500">
                            <nav className="list-none mb-7">
                              {cat.subCategories.map((subCategory, i) => (
                                <li
                                  key={i}
                                  className="flex flex-row-reverse justify-between px-2 py-[6px]"
                                >
                                  <Checkbox
                                    value={subCategory.id}
                                    label={subCategory.name}
                                    labelClass={
                                      'text-gray-200 text-lg font-normal leading-9 tracking-wider hover:text-white'
                                    }
                                    className={classNames(
                                      styles.checkColor,
                                      'mt-2 rounded-[0px] opacity-70'
                                    )}
                                  />
                                </li>
                              ))}
                            </nav>
                          </Disclosure.Panel>
                          {cat.category === 'Women' ? (
                            ''
                          ) : (
                            <div className="px-4 border-t border-gray-400 md:w-full b"></div>
                          )}
                        </>
                      )}
                    </Disclosure>
                  </div>
                </>
              )}
            </CheckboxGroup>
          </div>
        ))}
      </div>

      <div ref={divRef}>
        <div className="hidden md:px-2 sm:block">
          <div className="flex flex-wrap h-auto overflow-auto text-center md:text-left">
            <MainCheckBoxGroup
              name="categories"
              value={selectedCategories}
              onChange={handleCategoryChange}
            >
              {(Checkbox) => (
                <>
                  {categories.map((cat, i) => (
                    <div
                      className={`lg:w-1/${getColumns(categories?.length)} md:w-1/3 w-full`}
                      key={i}
                    >
                      <h2
                        className="mt-8 mb-1 text-sm text-white tagline-font cursor-pointer"
                        onClick={() => onParentCategoryClick(cat?.category)}
                      >
                        {cat.category}
                      </h2>
                      <nav className="mt-3 text-sm font-normal leading-7 list-none">
                        {cat.subCategories.map((subCategory, i) => (
                          <li key={i}>
                            <Checkbox
                              value={subCategory.id}
                              name={subCategory.name}
                              label={subCategory.name}
                              labelClass={`${
                                navigator.userAgent.indexOf('Mac') != -1
                                  ? 'bottom-[5px]'
                                  : 'bottom-[2px]'
                              } relative flex-1 ml-2 text-neutral-500 font-sm leading-6 hover:text-white cursor-pointer`}
                              className={classNames(styles.checkColor2, 'rounded-[0px]')}
                            />
                          </li>
                        ))}
                      </nav>
                    </div>
                  ))}
                </>
              )}
            </MainCheckBoxGroup>
          </div>
          <div className="w-full mt-10 mb-5 border-t border-custom-gray-80"></div>
          <Button
            className="flex items-center justify-center px-16 mx-auto my-8 tracking-widest button-style button-hover group"
            icon={
              <HiOutlineArrowRight className="inline-block w-4 h-5 pb-1 text-white ml-9 group-hover:text-black" />
            }
            label="Filter"
            handleClick={handleFilterSpeakers}
          />
        </div>
      </div>
    </>
  )
}

export default React.memo(Category)
